import * as Yup from "yup";
import { useTranslation } from "react-i18next";
import { parse, isValid } from "date-fns";

export function VoucherValidationSchema() {
  const { t } = useTranslation();

  const validation = Yup.object().shape({
    code: Yup.string()
      .min(3, t("LABEL.min"))
      .max(50, t("LABEL.max"))
      .required(t("LABEL.required")),
    type: Yup.string()
      .min(3, t("LABEL.min"))
      .max(50, t("LABEL.max"))
      .required(t("LABEL.required")),
    value: Yup.string().required(t("LABEL.required")),
    expiration: Yup.date()
      .transform(function (value, originalValue) {
        if (this.isType(value)) {
          return value;
        }

        let parsedDate = parse(originalValue, "dd.MM.yyyy", new Date());
        if (isValid(parsedDate)) {
          return parsedDate;
        }

        parsedDate = parse(originalValue, "dd/MM/yyyy", new Date());
        if (isValid(parsedDate)) {
          return parsedDate;
        }

        return new Date("");
      })
      .typeError(t("LABEL.invalid date"))
      .required(t("LABEL.select a date")),
  });

  return validation;
}
